import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getApiUrl() {
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl && !envUrl.includes('localhost') && !envUrl.includes('127.0.0.1')) {
    return envUrl.replace(/\/+$/, '');
  }
  return 'https://backend.ayurdnyanam.com';
}

export function getFileUrl(path: string | null | undefined) {
  if (!path) return "";
  const baseUrl = getApiUrl();
  if (path.startsWith("http://") || path.startsWith("https://")) {
    if (path.includes("127.0.0.1") || path.includes("localhost")) {
      return path.replace(/https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?/, baseUrl);
    }
    return path;
  }
  const cleanPath = path.replace(/^\/+/, "");
  if (cleanPath.startsWith("uploads/")) {
    return `${baseUrl}/${cleanPath}`;
  }
  return `${baseUrl}/uploads/${cleanPath}`;
}
